// #BACE60 -> #2B96D8
export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#DBBA61',
    light: '#6D6F73',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#222222',
    contrastText: '#0A5285',
    light: '#D9EDF7',
  },
  text: {
    primary: '#363635',
    secondary: '#273645',
    light: '#64748B',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    link: '#90D0FF',
    border: '#E5EAF4',
    header: '#559CFF',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#222222',
    paper: '#FFF',
    default: '#FFF',
    header: '#DBBA61',
    footer: 'rgba(242, 242, 242, 0.8)',
    level2: '#f7f8fb',
    level1: '#FFF',
    steps: '#000000',
    tableHead: '#DBBB5F',
    tableSubhead: '#F7F7F7',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#d4f1f9',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#DBBB5F',
    secondary: 'rgb(240,243,243)',
    light: '#F7F7F7',
    secondaryLight: '#FBF7F5',
    freebie: 'rgba(224, 237, 255, 0.3)'
  },
  verticalBar: {
    used: '#000000',
    unused: '#6D6F73',
    unlimited: '#C0C0C0',
  },
};
